import extendedFormsStyle from "assets/jss/material-dashboard-pro-react/views/extendedFormsStyle.jsx";
import customCheckboxRadioSwitch from "assets/jss/material-dashboard-pro-react/customCheckboxRadioSwitch.jsx";
import customInputStyle from "assets/jss/material-dashboard-pro-react/components/customInputStyle.jsx";
import buttonGroupStyle from "assets/jss/material-dashboard-pro-react/buttonGroupStyle.jsx";


import {
  containerFluid,
  defaultFont,
  primaryColor,
  defaultBoxShadow,
  infoColor,
  successColor,
  warningColor,
  dangerColor,
  whiteColor,
  grayColor,
  title,
  cardTitle
} from "assets/jss/material-dashboard-pro-react.jsx";


export const styles = {
  infoText: {
    fontWeight: "300",
    fontSize: "1.1em",
    margin: "10px 0 30px",
    textAlign: "left",

  },
  inputAdornmentIcon: {
    color: "#555"
  },
  inputAdornment: {
    position: "relative"
  },
  border: {
    border: "5px solid lightgray",
  },
  border1px: {
    border: "1px solid lightgray",
  },
  border1pxHorizontal: {
    borderWidth: "1px 0px 1px 0px",
    borderStyle: "solid",
    birderColor: "lightgray",
  },
  border1pxPink: {
    border: "1px solid pink",
    backgroundColor: "pink"
  },
  ...extendedFormsStyle,
  ...customCheckboxRadioSwitch,
  ...customInputStyle,
  ...buttonGroupStyle,
  padding15px: {
    padding: "0 15px !important",
  },
  gridItem: {
    padding: "0 0px !important",
    margin: "0 0px !important"
  },
  cardTitle: {
    color: "white",
    paddingLeft: 20,
    paddingRight: 20,
  },
  card: {
    "&:last-child": {
      marginBottom: "20px"
    }
  },
  gridContainerCenter: {
    justifyContent: 'center',
    alignItem: 'center',
  },
  infoIcon: {
    position: 'absolute',
    right: 0,
    top: 10,
  },
  infoIconForQuestion: {
    paddingLeft: 10,
    marginTop: 10,
  },
  question: {
    flexGrow: 1,
    flexDirection: 'column'
  },
  tipArea: {
    padding: 16,
  },
  cardText: {
    padding: "0px",
  },
  required: {
    border: "1px solid",
    color: dangerColor[0],
    fontSize: "0.7em",
    margin: "0px 8px 0px 0px",
    padding: "0px 4px 0px 4px",
    verticalAlign: "middele",
    borderRadius: 2,
  },
  inputSelectionExampleText: {
    fontSize: '0.9em'
  }
};

export default styles;